import { supabase } from './supabase';

function readHashParams(): URLSearchParams {
  const hash = window.location.hash.startsWith('#')
    ? window.location.hash.slice(1)
    : window.location.hash;
  return new URLSearchParams(hash);
}

export async function completeAdminAuthCallback(): Promise<{ error: string | null }> {
  const query = new URLSearchParams(window.location.search);
  const code = query.get('code');
  const hashParams = readHashParams();
  const accessToken = hashParams.get('access_token');
  const refreshToken = hashParams.get('refresh_token');
  const authError = query.get('error_description') ?? query.get('error');

  if (authError) {
    return { error: authError };
  }

  if (code) {
    const { error } = await supabase.auth.exchangeCodeForSession(code);
    if (error) {
      return { error: error.message };
    }
    return { error: null };
  }

  if (accessToken && refreshToken) {
    const { error } = await supabase.auth.setSession({
      access_token: accessToken,
      refresh_token: refreshToken,
    });
    if (error) {
      return { error: error.message };
    }
    return { error: null };
  }

  const { data: { session } } = await supabase.auth.getSession();
  if (session) {
    return { error: null };
  }

  return { error: 'Sign-in link is invalid or has expired.' };
}
